import classNames from "classnames";
import React from "react";
import { useFeatureFlag } from "../../../launch-darkly/useLaunchDarkly";
import { useWebOnboardingSteps } from "../hooks/useWebOnboardingSteps";
import { WebOnboardingStep } from "../WebOnboarding.util";

const tabsInitial = ["Intro", "Schedule", "Automate", "Setup"];
type OnboardingStateTab = typeof tabsInitial[number];

const selectedTab = (currentStep: WebOnboardingStep): OnboardingStateTab => {
  switch (currentStep) {
    case WebOnboardingStep.GetToKnowYou:
    case WebOnboardingStep.TeamJoinCreate:
    case WebOnboardingStep.AIScheduler:
      return "Intro";
    case WebOnboardingStep.Schedule:
    case WebOnboardingStep.Links:
      return "Schedule";
    case WebOnboardingStep.FocusTime:
    case WebOnboardingStep.Lunch:
    case WebOnboardingStep.Defrag:
    case WebOnboardingStep.FlexMeeting:
    case WebOnboardingStep.Invite:
      return "Automate";
    case WebOnboardingStep.Slack:
    case WebOnboardingStep.DownloadClockwise:
    case WebOnboardingStep.Finished:
      return "Setup";
    default:
      return "Setup";
  }
};

export const StepCounter = () => {
  const { stepCounterStep, totalSteps, currentStep } = useWebOnboardingSteps();
  const [isOnAIOnboarding] = useFeatureFlag("rollout-ai-onboarding");

  if (isOnAIOnboarding) {
    if (currentStep === WebOnboardingStep.GetToKnowYou) {
      return null;
    }
    const selectedTabValue = selectedTab(currentStep);
    return (
      <div className="cw-flex cw-gap cw-text-center md:cw-body-base cw-body-sm cw-text-subtle cw-pb-4">
        {["Intro", "Schedule", "Automate", "Setup"].map((tab) => (
          <div
            key={tab}
            className={classNames("cw-px-3 cw-h-6 cw-pb-0.5", {
              "cw-text-default cw-font-medium cw-border-b cw-border-solid cw-border-positive-emphasis":
                tab === selectedTabValue,
            })}
          >
            {tab}
          </div>
        ))}
      </div>
    );
  }

  return stepCounterStep ? (
    <div className="cw-text-center md:cw-body-base cw-body-sm cw-text-muted cw-my-2 md:cw-my-4">
      Step {stepCounterStep} of {totalSteps}
    </div>
  ) : null;
};
